__webpack_require__.p = "/marvel_assemble-react-ts/";